import { render, staticRenderFns } from "./SaveTransactionSidebar.vue?vue&type=template&id=afac8a4c&scoped=true"
import script from "./SaveTransactionSidebar.vue?vue&type=script&lang=js"
export * from "./SaveTransactionSidebar.vue?vue&type=script&lang=js"
import style0 from "./SaveTransactionSidebar.vue?vue&type=style&index=0&id=afac8a4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afac8a4c",
  null
  
)

export default component.exports